import evaluateDispensaryFeatureFlag from 'shared/utils/evaluate-dispensary-feature-flag';

export const MINIMUM_AGE_OVERRIDES_FLAG = 'ecomm.minimum-age-overrides.rollout';

let rawMinimumAgeOverridesFlagValue: unknown = false;

export function setMinimumAgeOverridesFlag(value: unknown): void {
  rawMinimumAgeOverridesFlagValue = value;
}

export function isMinimumAgeOverridesEnabled(dispensaryId = ''): boolean {
  return !!evaluateDispensaryFeatureFlag(MINIMUM_AGE_OVERRIDES_FLAG, rawMinimumAgeOverridesFlagValue, dispensaryId);
}
